import { render, staticRenderFns } from "./quizWeb.vue?vue&type=template&id=286d97f7&scoped=true&"
import script from "./quizWeb.vue?vue&type=script&lang=js&"
export * from "./quizWeb.vue?vue&type=script&lang=js&"
import style0 from "./quizWeb.vue?vue&type=style&index=0&id=286d97f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286d97f7",
  null
  
)

export default component.exports